import { action, makeObservable, observable } from 'mobx';
import { winPopupShownMinOdd } from '../gameConstants';

class WinPopupStore {
  isOpenWinPopup = false;

  winPopupTypeOddValue = 0;

  isFinishPopupAnimation = false;

  constructor() {
    makeObservable(this, {
      isOpenWinPopup: observable,
      winPopupTypeOddValue: observable,
      isFinishPopupAnimation: observable,
      winPopupOpen: action.bound,
      winPopupClose: action.bound,
      setIsOpenWinPopup: action.bound,
      setWinPopupTypeOddValue: action.bound,
      setIsFinishPopupAnimation: action.bound,
    });
  }

  setIsFinishPopupAnimation(bool) {
    this.isFinishPopupAnimation = bool;
  }

  setIsOpenWinPopup(bool) {
    this.isOpenWinPopup = bool;
  }

  setWinPopupTypeOddValue(value) {
    this.winPopupTypeOddValue = value;
  }

  winPopupOpen(odd) {
    if (odd >= winPopupShownMinOdd) this.setIsOpenWinPopup(true);
    this.setWinPopupTypeOddValue(odd);
  }

  winPopupClose = () => {
    this.setIsOpenWinPopup(false);
    this.setWinPopupTypeOddValue(null);
  };
}

export const winPopupStore = new WinPopupStore();
